import React from "react";

const Pulse: React.FC<{ className: string }> = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 ${className}`} />
);

const MobilePageSkeleton: React.FC = () => (
  <div className="h-full overflow-hidden bg-gray-50 px-4 pt-[calc(env(safe-area-inset-top)_+_1.25rem)]">
    <div className="flex items-start justify-between gap-3">
      <div className="space-y-2">
        <Pulse className="h-7 w-40 rounded-lg" />
        <Pulse className="h-3 w-56 rounded-full" />
      </div>
      <Pulse className="h-10 w-10 rounded-full" />
    </div>
    <div className="mt-6 flex gap-2.5 overflow-hidden">
      {[0, 1, 2].map((i) => (
        <Pulse key={i} className="h-24 w-[44%] min-w-[150px] shrink-0 rounded-2xl" />
      ))}
    </div>
    <Pulse className="mt-5 h-11 w-full rounded-xl" />
    <div className="mt-4 space-y-2.5">
      {[0, 1, 2, 3, 4].map((i) => (
        <Pulse key={i} className="h-24 w-full rounded-2xl" />
      ))}
    </div>
  </div>
);

export default MobilePageSkeleton;
